import {Route, Routes} from "react-router-dom";
import {ManualGrading} from "./pages/ManualGrading";
import {Urls} from "component/const/Urls";
import {AutoGrading} from "./pages/AutoGrading";

export const Grading = () => (
    <Routes>
        <Route index Component={ManualGrading}/>
        <Route path={Urls.auto} Component={AutoGrading}/>
    </Routes>
)